import { View, StyleSheet, Pressable, Platform } from "react-native";
import React, { memo } from "react";
import Animated, { FadeInDown } from "react-native-reanimated";

import ExperienceIcons from "../../../../assets/Icons/ExperienceIcons";
import CustomComponent from "../../../../components/CustomComponent";
import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../../../globalStyles/globalStyles";
import dimensions from "../../../../globalStyles/dimensions";
import { scale } from "style-value-types";

const TopSection = (props: any) => {
  const { isIcon }: { isIcon: any } = props;

  const navigation = useNavigation();
  return (
    <Animated.View entering={FadeInDown.delay(300)} style={styles.contentContainer}>
      <View style={styles.itemContainer1}>
        <CustomComponent.TextView
          title="Discover Experiences"
          textStyle={[
            GlobalStyles.heading3,
            {
              fontFamily: "EBGaramondSemiBold",
              fontSize: 32,
              lineHeight: 37,
              letterSpacing: -0.4,
            },
          ]}
        />
        {isIcon ? (
          <Pressable
            android_ripple={{ color: "#A5A9BC", borderless: true }}
            onPress={() => navigation.goBack()}
          >
            <ExperienceIcons.CircleIcon>
              <ExperienceIcons.Cross color={"black"} />
            </ExperienceIcons.CircleIcon>
          </Pressable>
        ) : (
          <Pressable
            android_ripple={{ color: "#A5A9BC", borderless: false }}
            onPress={() => {
              navigation.navigate("bookings" as never);
            }}
            style={{overflow: 'hidden'}}
          >
            <View
              style={[{
                paddingHorizontal: dimensions.paddingHorizontal / 2,
                paddingVertical: dimensions.paddingVertical / 3,
              },{
                transform: [{scale: 1.3}]
              }]}
            >
              <ExperienceIcons.HeartCalender />
            </View>
          </Pressable>
        )}
      </View>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  contentContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: Platform.OS === "ios" ? 30 : 20,
  },
  itemContainer1: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  textStyle: {
    fontSize: 24,
    color: "#000",
    fontFamily: "Playfair Display",
    fontStyle: "normal",
    fontWeight: "700",
    letterSpacing: 0.24,
  },
});

export default memo(TopSection);
